'use strict';

DoohApps
    .factory('ReportData', ['restApi', function (restApi) {
    var controllerName = 'Company/';

    return {

        getReportData: function (successCallback) {
            restApi.GetApiMethod(successCallback, controllerName + 'GetReportData');
        },
        getReportById: function (successCallback, id) {
            restApi.GetApiMethod(successCallback, controllerName + 'GetReportById?reportId=' + id);
        },
        updateReport: function (successCallback, report) {
            restApi.PutApiMethod(successCallback, controllerName + 'PutReport', report);
        },
        addReport: function (successCallback, report) {
            restApi.PostApiMethod(successCallback, controllerName + 'PostReport', report);
        },
        deleteReport: function (successCallback, id) {
            restApi.DeleteApiMethod(successCallback, controllerName + 'DeleteReport?Id=' + id);
        },
    }
}]);
